module.exports = __webpack_public_path__ + "static/media/pixeled-box-pink.281d65f6.svg";